/* global axios */
import ApiClient from './ApiClient';

class ContactInteractionsAPI extends ApiClient {
  constructor() {
    super('contact_interactions', { accountScoped: true });
  }

  get(page = 1, search = '') {
    return axios.get(this.url, {
      params: { page, ...(search ? { q: search } : {}) },
    });
  }
}

export default new ContactInteractionsAPI();
